/**
 * Horas efectivas de un tareo según configuración de tareo simple (solo para planilla).
 * Los registros de tareo siempre conservan horas_trabajadas reales.
 * - reales: usa horas_trabajadas del registro
 * - fijas_8: asistio / feriado_laborado / descanso_laborado → 8h en el conteo de planilla
 */
export function modoHorasSimpleDeConfig(configuracionTareo) {
  const modo = String(configuracionTareo?.modo_horas_simple || 'reales').toLowerCase().trim();
  return modo === 'fijas_8' ? 'fijas_8' : 'reales';
}

export function esTareoSimple(configuracionTareo) {
  return (
    Number(configuracionTareo?.tipo_tareo) === 1
    || configuracionTareo?.es_simple === true
  );
}

export function usaHorasFijas8Simple(configuracionTareo) {
  return esTareoSimple(configuracionTareo) && modoHorasSimpleDeConfig(configuracionTareo) === 'fijas_8';
}

const TIPOS_JORNADA_FIJA = new Set(['asistio', 'feriado_laborado', 'descanso_laborado']);

export function horasTrabajadasEfectivas(tareo, configuracionTareo) {
  if (tareo?.horas_planilla != null && Number.isFinite(Number(tareo.horas_planilla))) {
    return Number(tareo.horas_planilla);
  }
  const tipo = String(tareo?.tipo_evento || '').toLowerCase().trim();
  const horas = parseFloat(tareo?.horas_trabajadas) || 0;
  if (usaHorasFijas8Simple(configuracionTareo) && TIPOS_JORNADA_FIJA.has(tipo)) {
    return 8;
  }
  return horas;
}

export default {
  modoHorasSimpleDeConfig,
  esTareoSimple,
  usaHorasFijas8Simple,
  horasTrabajadasEfectivas,
};
